document.addEventListener('DOMContentLoaded', function () {
  const compWrapper = document.querySelector('.complementary-wrapper');
  if (!compWrapper) return;

  let cartDrawerNeedsRefresh = false;

  updateCompButtons();
  setupCartIconRefresh();

  compWrapper.addEventListener('click', function (e) {
    const plusBtn = e.target.closest('.plus');
    const minusBtn = e.target.closest('.minus');
    const addBtn = e.target.closest('.comp-add-btn');

    if (plusBtn) {
      e.preventDefault();
      const input = plusBtn.previousElementSibling;
      input.value = parseInt(input.value || 1) + 1;
      return;
    }

    if (minusBtn) {
      e.preventDefault();
      const input = minusBtn.nextElementSibling;
      if (parseInt(input.value || 1) > 1) input.value = parseInt(input.value || 1) - 1;
      return;
    }

    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();

      if (addBtn.disabled) return;

      const card = addBtn.closest('.comp-card');
      const qty = card.querySelector('.comp-quantity-input').value || 1;
      const variantId = addBtn.dataset.variantId;

      addToCart(variantId, qty, addBtn);
    }
  });

  function addToCart(id, qty, btn) {
    const textSpan = btn.querySelector('.btn-text');
    const spinner = btn.querySelector('.loading-spinner');
    const originalText = textSpan.innerText;

    textSpan.innerText = 'Adding...';
    if (spinner) spinner.classList.remove('hidden');
    btn.classList.add('loading');

    const currentProductId = document.querySelector('product-info')?.dataset.productId || '';

    const formData = {
      items: [
        {
          id: parseInt(id),
          quantity: parseInt(qty),
          properties: {
            _parent_product_id: currentProductId,
            _parent_product_handle: window.location.pathname
          }
        }
      ]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => response.json())
      .then(() => {
        btn.disabled = true;
        textSpan.innerText = 'Added';
        if (spinner) spinner.classList.add('hidden');
        btn.classList.remove('loading');
        btn.closest('.comp-card').classList.add('in-cart-active');

        cartDrawerNeedsRefresh = true;

        updateCartBubbleOnly();
        setTimeout(updateCompButtons, 500);
      })
      .catch((error) => {
        console.error('Underbody kit add error:', error);
        textSpan.innerText = originalText;
        if (spinner) spinner.classList.add('hidden');
        btn.classList.remove('loading');
      });
  }

  function setupCartIconRefresh() {
    document.addEventListener(
      'click',
      function (e) {
        const cartIcon = e.target.closest('#cart-icon-bubble');

        if (!cartIcon || !cartDrawerNeedsRefresh) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        refreshCartDrawerFromServer().then(() => {
          cartDrawerNeedsRefresh = false;

          const cartDrawer = document.querySelector('cart-drawer');

          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open(cartIcon);
          } else {
            window.location.href = cartIcon.getAttribute('href') || '/cart';
          }
        });
      },
      true
    );
  }

  function refreshCartDrawerFromServer() {
    return fetch(window.Shopify.routes.root + '?sections=cart-drawer')
      .then((res) => res.json())
      .then((sections) => {
        const cartDrawerHtml = sections['cart-drawer'];
        if (!cartDrawerHtml) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(cartDrawerHtml, 'text/html');

        const newCartDrawer = doc.querySelector('cart-drawer');
        const currentCartDrawer = document.querySelector('cart-drawer');

        if (newCartDrawer && currentCartDrawer) {
          currentCartDrawer.replaceWith(newCartDrawer);
        }
      })
      .catch((error) => {
        console.warn('Cart drawer refresh skipped:', error);
      });
  }

  function updateCartBubbleOnly() {
    fetch(window.Shopify.routes.root + '?sections=cart-icon-bubble')
      .then((res) => res.json())
      .then((sections) => {
        const bubbleHtml = sections['cart-icon-bubble'];
        if (!bubbleHtml) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(bubbleHtml, 'text/html');

        const newBubble = doc.querySelector('#cart-icon-bubble');
        const currentBubble = document.querySelector('#cart-icon-bubble');

        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }
      })
      .catch((error) => {
        console.warn('Cart bubble update skipped:', error);
      });
  }

  function updateCompButtons() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const currentProductId = document.querySelector('product-info')?.dataset.productId || '';

        document.querySelectorAll('.comp-add-btn').forEach((btn) => {
          const btnVariantId = parseInt(btn.dataset.variantId);
          const textSpan = btn.querySelector('.btn-text');
          const spinner = btn.querySelector('.loading-spinner');
          const card = btn.closest('.comp-card');

          if (spinner) spinner.classList.add('hidden');

          const existsForThisProduct = cart.items.some((item) => {
            return (
              item.variant_id === btnVariantId &&
              item.properties &&
              item.properties._parent_product_id === currentProductId
            );
          });

          if (existsForThisProduct) {
            btn.disabled = true;
            textSpan.innerText = 'Added';
            btn.classList.remove('loading');
            card.classList.add('in-cart-active');
          } else if (textSpan.innerText !== 'Sold Out') {
            btn.disabled = false;
            textSpan.innerText = 'Add';
            btn.classList.remove('loading');
            card.classList.remove('in-cart-active');
          }
        });
      });
  }

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('cart-remove-button') ||
      e.target.closest('[name="updates[]"]') ||
      e.target.closest('.quantity__button')
    ) {
      setTimeout(updateCompButtons, 800);
      setTimeout(updateCompButtons, 1500);
    }
  });
});